import { render, staticRenderFns } from "./cutWater.vue?vue&type=template&id=24756374&scoped=true&"
import script from "./cutWater.vue?vue&type=script&lang=js&"
export * from "./cutWater.vue?vue&type=script&lang=js&"
import style0 from "./cutWater.vue?vue&type=style&index=0&id=24756374&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24756374",
  null
  
)

export default component.exports